import { MouseEventHandler, ReactNode } from 'react';

import Button from '@components/Button/next';

import { Wrapper } from './styled';

const BookerSearchButton = ({
  onClick,
}: {
  onClick: MouseEventHandler<HTMLElement> | undefined;
  children?: ReactNode;
}) => {
  return (
    <Wrapper>
      <Button
        block
        variant='Primary'
        onClick={onClick}
        borderRadius={8}
        aria-label='Ara'
      >
        Ara
      </Button>
    </Wrapper>
  );
};

export default BookerSearchButton;
